import { Stack, styled } from '@mui/material';

export const Cell = styled(Stack)(({ theme }) => ({
  background: theme.palette.grey[700],
  borderRadius: '3px',
  padding: '2px 6px',
  gap: 1,
}));

export const CellNew = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: 16,
  padding: '7px 10px',
}));
